module.exports = __webpack_public_path__ + "media/images/svgs/jobs/hand-5f676e22ab5e6cba3dc447d1d6bbb1ac.svg";